<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlertMandatoryQty" variant="warning" dismissible>
    La quantità è un parametro obbligatorio
  </b-alert>

  <b-alert v-model="showAlertMandatoryLocations" variant="warning" dismissible>
    Le locazioni sono parametri obbligatori
  </b-alert>

  <b-alert v-model="showAlertMandatoryNotFound" variant="info" dismissible>
    Non sono stati trovati dati corrispondenti con i parametri impostati
  </b-alert>


  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Richiesta Preventivo"
      >

        <b-card-body style="text-align: left;">

          <!-- Nome listino e nome cliente -->
          <b-row>
            <b-col cols='6'>
              <div class='label'>Cliente</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Listino</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='6'> 
              <select class="custom-select" v-model="selectedCustomer" @change="updatePriceList">
                <option></option>
                <option
                  v-for="customer in customers"
                  :key="customer.id"
                  :value="customer.id"                  
                >
                 {{ customer.company }}
                </option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="selectedPriceListName"
              >
                <option></option>
                <option 
                  v-for="price_list_name in price_list_names" 
                  :key="price_list_name.id" 
                  :value="price_list_name.price_list_name"
                >
                  {{ price_list_name.price_list_name }}
                </option>
              </select>
            </b-col>
          </b-row>
          
          <!-- Nome della voce e valuta -->
          <b-row>
            <b-col cols='6'>
              <div class='label'>Unità di misura</div> 
            </b-col>
            <b-col cols='3'>
              <div class='label'>Quantità</div> 
            </b-col>
            <b-col cols='3'>
              <div class='label'>Valuta</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="selectedUM"
              >
                <option></option>
                <option 
                  v-for="measure_unit in measure_units" 
                  :key="measure_unit.id" 
                  :value="measure_unit.id"
                >
                  {{ measure_unit.measure_unit }}
                </option>
              </select>
            </b-col>
            <b-col cols='3'>
              <b-form-input v-model="quantity" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='3'>
              <select 
                class="custom-select"
                v-model="selectedCurrency"
              >
                <option></option>
                <option 
                  v-for="currency in currencies" 
                  :key="currency.id" 
                  :value="currency.id"
                >
                  {{ currency.currency }}
                </option>
              </select>
            </b-col>
          </b-row>

          <!-- Locazione 1 e Locazione 2 -->
          <b-row>
            <b-col cols='6'>
              <div class='label'>Locazione 1</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Locazione 2</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="selectedLocationId1"
              >
                <option></option>
                <option v-for="location in locations" :key="location.value" :value="location.value">{{ location.text }}</option>
              </select>
            </b-col>
            <b-col cols='6'>
              <select 
                class="custom-select"
                v-model="selectedLocationId2"
              >
                <option></option>
                <option v-for="location in locations" :key="location.value" :value="location.value">{{ location.text }}</option>
              </select>
            </b-col>
          </b-row>
          
          <!-- Base -->
          <b-row>
            <b-col cols='12'>
              <div class='label'>Base</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='12'>
              <select 
                class="custom-select"
                v-model="selectedBase"
              >
                <option></option>
                <option 
                  v-for="base in bases" 
                  :key="base.id" 
                  :value="base.id"
                >
                  {{ base.base_code }}
                </option>
              </select>
            </b-col>
          </b-row>

          <!-- Scaglione minimo e massimo e uita' di misura-->
          <b-row>
            <b-col cols='5'>
              <div class='label'>Scaglione minimo</div> 
            </b-col>
            <b-col cols='5'>
              <div class='label'>Scaglione massimo</div> 
            </b-col>
            <b-col cols='2'>
              <div class='label'>Unità di misura dello scaglione</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='5'>
              <b-form-input v-model="lower_end_bracket" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='5'>
              <b-form-input v-model="upper_end_bracket" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='2'>
              <select 
                class="custom-select"
                v-model="selectedBracketMeasureUnit"
              >
                <option></option>
                <option 
                  v-for="bracket_measure_unit in bracket_measure_units" 
                  :key="bracket_measure_unit.id" 
                  :value="bracket_measure_unit.id"
                >
                  {{ bracket_measure_unit.measure_unit }}
                </option>
              </select>
            </b-col>
          </b-row>
          
          <!-- Formula, importo voce attiva e voce passiva -->
          <b-row>
            <b-col cols='4'>
              <div class='label'>Formula</div> 
            </b-col>
            <b-col cols='4'>
              <div class='label'>Voce attiva</div> 
            </b-col>
            <b-col cols='4'>
              <div class='label'>Voce passiva</div> 
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='4'>
              <select 
                class="custom-select"
                v-model="selectedCalculationFormula"
              >
                <option></option>
                <option 
                  v-for="calculation_formula in calculation_formulas" 
                  :key="calculation_formula.id" 
                  :value="calculation_formula.id"
                >
                  {{ calculation_formula.formula }}
                </option>
              </select>
            </b-col>
            <b-col cols='4'>
              <b-form-input v-model="active_voice" class="custom-input"></b-form-input>
            </b-col>
            <b-col cols='4'>
              <b-form-input v-model="passive_voice" class="custom-input"></b-form-input>
            </b-col>
          </b-row>

          <!--tipo merce, tipo imballaggio, dimensioni equipaggiamento, ¿tipologia di listino? -->
          <b-row>
            <b-col cols='4'>
              <div class='label'>Tipologia merce</div> 
            </b-col>
            <b-col cols='4'>
              <div class='label'>Tipologia imballaggio</div> 
            </b-col>
            <b-col cols='4'>
              <div class='label'>Dimensioni equipaggiamento</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='4'>
              <select 
                class="custom-select"
                v-model="selectedGoodsKind"
              >
                <option></option>
                <option 
                  v-for="good_kind in goods_kinds" 
                  :key="good_kind.id" 
                  :value="good_kind.id"
                >
                  {{ good_kind.kind }}
                </option>
              </select>
            </b-col>
            <b-col cols='4'>
              <select 
                class="custom-select"
                v-model="selectedPackagingKind"
              >
                <option></option>
                <option 
                  v-for="packaging_kind in packaging_kinds" 
                  :key="packaging_kind.id" 
                  :value="packaging_kind.id"
                >
                  {{ packaging_kind.description }}
                </option>
              </select>
            </b-col>
            <b-col cols='4'>
              <select 
                class="custom-select"
                v-model="selectedEquipmentSize"
              >
                <option></option>
                <option 
                  v-for="equipment_size in equipment_sizes" 
                  :key="equipment_size.id" 
                  :value="equipment_size.id"
                >
                  {{ equipment_size.size }}
                </option>
              </select>
            </b-col>
          </b-row>  

          <!-- Separatore -->
          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>

          <!-- Bottoni -->
          <b-row>
            <b-col cols="2">
              <b-button variant="outline-warning" @click="clearQuote">&nbsp;&nbsp;Azzera preventivi&nbsp;&nbsp;</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>                      
            <b-col cols="2">
              <b-button variant="outline-danger" @click="clearFilter">&nbsp;&nbsp;Pulisci dati&nbsp;&nbsp;</b-button>              
            </b-col>          
            <b-col cols="2">
              <b-button variant="outline-info" @click="exportToExcel">&nbsp;&nbsp;Esporta in excel&nbsp;&nbsp;</b-button>
            </b-col>                      
            <b-col cols="1">
              &nbsp;
            </b-col>                      
            <b-col cols="2">
              <b-button variant="primary" @click="calculateQuote">&nbsp;&nbsp;Calcola preventivo&nbsp;&nbsp;</b-button>
            </b-col>          
          </b-row>
        </b-card-body>
<!--      
        <b-card-body style="text-align: left;">

          <b-row v-if="isStaff">
            <b-col cols='12'>
              <div class='label'>Listino</div> 
            </b-col>
            <b-col cols='12'>
              <b-form-select v-model="customer" :options="customers"></b-form-select>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols='6'>
              <div class='label'>Formula</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Quantità</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'>
              <b-form-select v-model="calculation_formula" :options="calculation_formulas"></b-form-select>
            </b-col>
            <b-col cols='6'>
              <b-form-input v-model="quantity"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'>
              <div class='label'>Locazione 1</div> 
            </b-col>
            <b-col cols='6'>
              <div class='label'>Locazione 2</div> 
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='6'>
              <b-form-select v-model="location_code1" :options="locations"></b-form-select>
            </b-col>
            <b-col cols='6'>
              <b-form-select v-model="location_code2" :options="locations"></b-form-select>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>

          <b-row>
            <b-col cols="1">
              &nbsp;
            </b-col>          
            <b-col cols="3">
              <b-button variant="outline-warning" @click="clearQuote">&nbsp;&nbsp;Azzera&nbsp;&nbsp;</b-button>
            </b-col>          
            <b-col cols="4">
              &nbsp;
            </b-col>                      
            <b-col cols="3">
              <b-button variant="primary" @click="calculateQuote">&nbsp;&nbsp;Calcola preventivo&nbsp;&nbsp;</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
-->
      </b-card>
    </b-col>
  </b-row>

  <b-row>
    <b-col cols="12">

     <b-table :items="prices_list_rows" :fields="prices_list_columns"></b-table>

    </b-col>

  </b-row>

</div>